// Product titel, badge en reviews verplaatsen naar boven de pagina op mobiel
(function() {
  function moveProductElementsOnMobile() {
    // Alleen uitvoeren op mobiel
    if (window.innerWidth >= 990) return;
    
    // Selecteer de elementen
    const productPage = document.querySelector('.product-page');
    const productInfoMain = document.querySelector('.product-info-main.product-block');
    const productInfoSecondary = document.querySelector('.product-info-secondary');
    const mediaGallery = document.querySelector('.product-media-gallery-wrap');
    
    // Check of alle elementen bestaan
    if (!productPage || !productInfoMain || !mediaGallery) return;
    
    // Check of het al is verplaatst (voorkom duplicaten)
    if (productInfoMain.hasAttribute('data-moved-mobile')) return;
    
    // Clone de titel/badge
    const titleClone = productInfoMain.cloneNode(true);
    titleClone.setAttribute('data-moved-mobile', 'true');
    
    // Verberg het origineel
    productInfoMain.style.display = 'none';
    
    // Plaats de clone voor de media gallery
    productPage.insertBefore(titleClone, mediaGallery);
    
    // Verplaats ook reviews als die bestaan
    if (productInfoSecondary) {
      const reviewsClone = productInfoSecondary.cloneNode(true);
      reviewsClone.setAttribute('data-moved-mobile', 'true');
      
      // Verberg het origineel
      productInfoSecondary.style.display = 'none';
      
      // Plaats reviews na titel maar voor afbeeldingen
      productPage.insertBefore(reviewsClone, mediaGallery);
    }
  }
  
  function restoreProductElementsOnDesktop() {
    // Alleen uitvoeren op desktop
    if (window.innerWidth < 990) return;
    
    // Verwijder de mobile clones
    const movedElements = document.querySelectorAll('[data-moved-mobile="true"]');
    movedElements.forEach(el => el.remove());
    
    // Toon de originelen weer
    const originalTitle = document.querySelector('.product-info-main.product-block');
    const originalReviews = document.querySelector('.product-info-secondary');
    
    if (originalTitle) {
      originalTitle.style.display = '';
    }
    if (originalReviews) {
      originalReviews.style.display = '';
    }
  }
  
  function handleResize() {
    if (window.innerWidth < 990) {
      moveProductElementsOnMobile();
    } else {
      restoreProductElementsOnDesktop();
    }
  }
  
  // Uitvoeren bij laden
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleResize);
  } else {
    handleResize();
  }
  
  // Uitvoeren bij resize (met debounce)
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResize, 250);
  });
})();
